
import { KEPT_FORMER_ICHRA_LABEL, KEPT_FORMER_ICHRA_TOOLTIP, isKeptFormerIchra } from '~/util/former-ichra'

export default {
    name: 'KeptFormerIchraBadge',
    props: {
        // A search row or a survey payload.
        record: { type: Object, default: null },
    },
    data () {
        return { label: KEPT_FORMER_ICHRA_LABEL, tooltip: KEPT_FORMER_ICHRA_TOOLTIP }
    },
    computed: {
        kept () {
            return isKeptFormerIchra(this.record)
        },
    },
}
